import  codes from '@/codes';

//restful api
import { schedule as wmds } from '@/service/api/wmds'

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'group', label: 'Group', sortable: false },
    { key: 'site.fqdn', label: 'FQDN', sortable: false },
    { key: 'site.name', label: 'Name', sortable: false },
    { key: 'last_time', label: 'Last Time', sortable: true },
    { key: 'due_time', label: 'Next Time', sortable: true },
    { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 25%'  },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'group', label: '그룹', sortable: false },
    { key: 'site.fqdn', label: 'FQDN', sortable: false },
    { key: 'site.name', label: '이름', sortable: false },
    { key: 'last_time', label: '마지막 점검 시간', sortable: true },
    { key: 'due_time', label: '다음 점검 일정', sortable: true },
    { key: 'func', label: '더보기', sortable: false, thStyle: 'width: 25%'  },
  ]
}

export default {
  data: () => {
    return {
      confirm: undefined,
      selected: undefined,
      show: true,
      group : {},
      start : false,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
      hide_del : true,
    }
  },
  computed: {
    fields (){
      return i18n_fields[this.i18n];
    },
    rowCount() { return this.so.totalRows || 0; },
    startRow () { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
  },
  methods: {
    action(cmd = 'start', item) {
      switch (cmd) {
        case 'result':
          this.$router.push({ name: 'wmds_result', params: { site_id : item.site_id }});
          this.$emit('refresh')
          break;
        case 'site':
          this.$router.push({ name: 'wmds_site', params: { id : item.site_id }});
          this.$emit('refresh')
          break;
        case 'delay':
        case 'start':
          item.is_starting = true
          // Api.Manager({ target : 'wmds.schedule', cmd : cmd, body : { site_id : item.site_id } }).then(rs => {
            wmds.startSchedule({ site_id : item.site_id }).then(rs => {
            rs.error ? this.$toastr.w("failed", "custom ", cmd, " failed") : this.$toastr.s("done", "request", cmd)
          }).then(() => this.refresh()).catch(e => { this.$toastr.e(e.data ? e.data.message : e) })
          break;
      }
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.$refs._list.refresh();},
    refresh() { this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },

    // 현재 쓰고 있지 않아 주석처리
    // remove() {
    //   try{
    //     wmds.deleteSchedule({ id : this.selected.id })
    //     this.refresh(); this.$toastr.i('Schedule Remove Completion');
    //   } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText)  }
    // },

    load(ctx = {}) {
      let so = {
        body : { sort : [ { name : 'id', op : 'desc' } ], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim() && this.so.sk) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
        return wmds.listSchedule(so).then(rs => {
        if(rs.error) { return this.$$toastr.e("can't not load schedule") }
        this.so.totalRows = rs.total;
        (rs.body || []).forEach(r => r.is_starting = false);
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    hideList(e) { this.show = !e; console.log('schedule.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  created() { console.log('schedule.list.vue', 'created'); },
  destroyed() { console.log('schedule.list.vue', 'destroyed'); },
  mounted() {
    console.log('schedule.list.vue', 'mounted');
    try { this.start = location.hostname == "localhost" || location.hostname == "console.f1secaas.net"; } catch { this.start = false; }
  },
}